import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import SvgIcons from '../../../components/icons/SvgIcons';
import { Avatar, Box, IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';
import StatusLabel from '../../common/components/StatusLabel';

export const getSearchStudentFeeEntryColumns = (
  onFeeDetailsClick: (studentId: string) => void
): GridColDef[] => {
  return [
    {
      field: 'studentName',
      headerName: 'Student',
      flex: 1.5,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {params.row.studentProfile ? (
            <Avatar src={params.row.studentProfile} alt='Student Profile' />
          ) : (
            <SvgIcons.Avatar />
          )}
          {params.row.studentName}
        </Box>
      )
    },
    { field: 'enrollmentNo', headerName: 'Enrollment No', flex: 1 },
    { field: 'class', headerName: 'Class', flex: 0.8 },
    { field: 'fatherName', headerName: "Father's name", flex: 1.5 },
    { field: 'motherName', headerName: "Mother's name", flex: 1.5 },
    { field: 'studentEmail', headerName: "Student's email", flex: 2.5 },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.8,
      renderCell: (params: GridRenderCellParams) => (
        <StatusLabel status={params.value} />
      )
    },
    { field: 'studentType', headerName: 'Student Type', flex: 1.1 },
    {
      field: 'feeDetails',
      headerName: 'Action',
      flex: 1,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Tooltip title='Edit'>
          <IconButton onClick={() => onFeeDetailsClick(params.row.id)}>
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
      )
    }
  ];
};
